import { getItemLocalStorage, getItemWebStorage } from "../features/webStorageSaver";

export async function getCameraInfo(cameraId: string){
    try {
        const currentDataBase = getItemLocalStorage("lastEnteredDatabase")
        const currentConfig = getItemWebStorage('currentConfig')
        const roadWebCamsRoot = currentConfig?.roadWebCamsRoot
        let url = `https://${roadWebCamsRoot}/cams/${currentDataBase}/${cameraId}/${cameraId}.json`
        const response: any = await fetch(url, {
            method: 'GET'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch');
        } else{
            let data = await response.json()
            return data?.cameraInfo
        }
    } catch (error) {
        console.error('Fetch error:', error);
    }
}